module.exports = __webpack_public_path__ + "img/download_excelicon.70d7d825.svg";